/* ============================================================================
FILE: po-ordo-ab-chaos-collection-fr-en-es-20260727.js
ROLE: Description trilingue protégée de la collection « Ordo Ab Chaos ».
ROOT: [data-po-ordo-ab-chaos]
LANGUES: FR / EN / ES
STORAGE: po_lex_lang + goody_gp_lang
AUDIO: SpeechSynthesis, lecture du texte actif uniquement.
LIENS: Ordo Ab Chaos, RéZonans, Sujet pluriel, Engrenages,
       Multiple-pluriel et Posœnnoïsme.
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_ORDO_AB_CHAOS_COLLECTION_20260727__) return;
  window.__PO_ORDO_AB_CHAOS_COLLECTION_20260727__ = true;

  var ROOT_SELECTOR = "[data-po-ordo-ab-chaos]";
  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis)
    ? window.speechSynthesis
    : null;

  var AUDIO_STATE = {
    root: null,
    chunks: [],
    index: 0,
    active: false
  };

  function clampStr(value){
    return value == null ? "" : String(value);
  }

  function escapeHTML(value){
    return clampStr(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  var CANONICAL_LINKS = {
    ordo: "/collections/ordo-ab-chaos",
    rezonans: "/pages/rezonans",
    sujetPluriel: "/pages/sujet-pluriel",
    engrenages: "/pages/engrenages",
    multiplePluriel: "/pages/multiple-pluriel",
    posoennoisme: "/pages/posoennoisme"
  };

  function pageLink(value, href, isCanonical){
    var classes = "po-oac-collection__link";

    if (isCanonical) {
      classes += " po-oac-collection__canonical notranslate";
    }

    return '<a class="' + classes + '"' +
      (isCanonical ? ' translate="no"' : "") +
      ' href="' + escapeHTML(href) + '">' +
      escapeHTML(value) +
      "</a>";
  }

  function canonical(value, href){
    if (href) return pageLink(value, href, true);

    return '<span class="po-oac-collection__canonical notranslate" translate="no">' +
      escapeHTML(value) +
      "</span>";
  }

  var CANON = {
    ordo: canonical("Ordo Ab Chaos", CANONICAL_LINKS.ordo),
    rezonans: canonical("RéZonans", CANONICAL_LINKS.rezonans),
    sujetPluriel: canonical(
      "Sujet pluriel",
      CANONICAL_LINKS.sujetPluriel
    ),
    engrenages: canonical(
      "Engrenages",
      CANONICAL_LINKS.engrenages
    ),
    multiplePluriel: canonical(
      "Multiple-pluriel",
      CANONICAL_LINKS.multiplePluriel
    ),
    posoennoisme: canonical(
      "Posœnnoïsme",
      CANONICAL_LINKS.posoennoisme
    )
  };

  var CONTENT = {
    fr: {
      ui: {
        group: "Choix de la langue",
        summary: "Description",
        audio: "Écouter",
        stop: "Arrêter",
        content: "Description de la collection Ordo Ab Chaos"
      },
      paragraphs: [
        CANON.ordo + " prend naissance en 2015, au croisement d’une rencontre avec un univers particulier et d’un moment où ma pratique cherchait un nouvel élan. Cette rencontre lui donne un balan dynamique, accordé à mes réflexions sur l’espace-temps de l’humanité, sur les forces visibles et invisibles qui la traversent, sur les mémoires qui la travaillent et sur les tensions par lesquelles chaque être cherche sa place au milieu du monde.",

        "La collection parle de notre humanité, de ses luttes intérieures, de ses désirs, de ses violences, de ses élans, de ses contradictions et de leurs " + CANON.rezonans + " dans le cosmos, dans l’univers, dans la société et en l’Autre. Chaque œuvre devient une zone où l’infiniment intime rencontre l’infiniment vaste, où les conflits individuels entrent en relation avec les tensions collectives et où la couleur donne une présence sensible aux forces qui traversent le vivant.",

        "Le chaos y apparaît comme une pluralité de formes, de mémoires, d’affects et d’énergies en attente d’agencement. L’ordre y devient une cohérence mobile, une tenue capable d’accueillir les différences tout en préservant leur intensité. " + CANON.ordo + " déploie ainsi une unité hétérogène de la singularité, une expression plurielle du multiple dans laquelle les tensions, les rapprochements, les ruptures et les recompositions participent ensemble à la construction de l’œuvre.",

        "C’est dans cette collection que s’affirme la phrase-source de 2015 commençant par ces mots&nbsp;: «&nbsp;Je suis cette zone de contact entre le contour de la forme et l’autour qui constitue l’espace où s’exprime la forme.&nbsp;» Le «&nbsp;Je&nbsp;» qui l’ouvre appartient à tous les «&nbsp;Je&nbsp;» qui la lisent, la regardent et l’éprouvent. Chacun peut l’habiter et devenir cette zone de contact, cet espace de frictions, de tensions, de douceurs, de fusions, de chocs et d’éloignements où résonnent plusieurs mondes, plusieurs cultures, plusieurs histoires et plusieurs affects.",

        "Ce «&nbsp;Je&nbsp;» agit comme une place ouverte. Il accueille la singularité de chaque lecteur tout en la mettant en relation avec la multiplicité du monde. Celui qui entre dans la phrase devient à son tour le point de passage entre la forme et son autour, entre l’expérience intime et l’histoire collective, entre ce qu’il perçoit et ce qui le traverse. La lecture devient alors participation, et l’œuvre devient un espace dans lequel chacun peut reconnaître, déplacer et réaccorder sa propre relation au réel.",

        "Cette pensée porte déjà les germes du " + CANON.sujetPluriel + ", des " + CANON.engrenages + ", de " + CANON.rezonans + " et de l’esthétique du " + CANON.multiplePluriel + ", qui recevront plus tard leur formulation dans le " + CANON.posoennoisme + ". À travers " + CANON.ordo + ", la peinture rend perceptible le tumulte sans l’aplatir, donne aux tensions une architecture, aux différences un espace de relation et aux fragments une possibilité de recomposition.",

        "Chaque détail participe ainsi à une organisation plus ample. Le monde conserve son intensité, ses fractures, ses écarts et ses devenirs, tandis que l’œuvre fait surgir une forme capable de les contenir, de les déplacer et de les transformer. " + CANON.ordo + " devient alors un champ de passage où l’ordre procède du chaos, où la singularité s’éprouve dans le multiple et où chaque «&nbsp;Je&nbsp;» peut entrer dans la dynamique vivante de l’ensemble."
      ]
    },

    en: {
      ui: {
        group: "Language selection",
        summary: "Description",
        audio: "Listen",
        stop: "Stop",
        content: "Description of the Ordo Ab Chaos collection"
      },
      paragraphs: [
        CANON.ordo + " emerged in 2015 at the intersection of an encounter with a particular universe and a moment when my practice was seeking a new momentum. This encounter gave it a dynamic impulse attuned to my reflections on humanity’s space-time, on the visible and invisible forces that move through it, on the memories working within it, and on the tensions through which each being seeks a place in the midst of the world.",

        "The collection speaks about our humanity, its inner struggles, desires, violence, impulses, contradictions, and their " + CANON.rezonans + " in the cosmos, in the universe, in society, and within the Other. Each work becomes a zone where the infinitely intimate meets the infinitely vast, where individual conflicts enter into relation with collective tensions, and where colour gives a perceptible presence to the forces moving through the living.",

        "Chaos appears here as a plurality of forms, memories, affects, and energies awaiting arrangement. Order becomes a mobile coherence, a form of holding capable of welcoming differences while preserving their intensity. " + CANON.ordo + " thus unfolds a heterogeneous unity of singularity, a plural expression of the multiple in which tensions, convergences, ruptures, and recompositions participate together in the construction of the work.",

        "It is within this collection that the 2015 source-sentence asserts itself, beginning with these words: “I am this zone of contact between the outline of the form and the surrounding space that constitutes the place where the form is expressed.” The “I” that opens it belongs to every “I” who reads, looks at, and experiences it. Each person can inhabit it and become this zone of contact, this space of frictions, tensions, gentlenesses, fusions, shocks, and distances where several worlds, cultures, histories, and affects resonate.",

        "This “I” acts as an open place. It welcomes the singularity of each reader while bringing it into relation with the multiplicity of the world. Whoever enters the sentence becomes, in turn, the point of passage between the form and its surrounding space, between intimate experience and collective history, between what is perceived and what moves through the perceiver. Reading then becomes participation, and the work becomes a space in which each person can recognise, shift, and retune their own relation to reality.",

        "This thought already carries the seeds of the " + CANON.sujetPluriel + ", the " + CANON.engrenages + ", " + CANON.rezonans + ", and the aesthetics of the " + CANON.multiplePluriel + ", which would later receive their formulation within the " + CANON.posoennoisme + ". Through " + CANON.ordo + ", painting makes turmoil perceptible without flattening it, gives tensions an architecture, differences a relational space, and fragments a possibility of recomposition.",

        "Each detail thus participates in a broader organisation. The world retains its intensity, fractures, intervals, and becomings, while the work brings forth a form capable of holding, shifting, and transforming them. " + CANON.ordo + " then becomes a field of passage where order proceeds from chaos, where singularity is experienced within the multiple, and where every “I” can enter the living dynamic of the whole."
      ]
    },

    es: {
      ui: {
        group: "Selección de idioma",
        summary: "Descripción",
        audio: "Escuchar",
        stop: "Detener",
        content: "Descripción de la colección Ordo Ab Chaos"
      },
      paragraphs: [
        CANON.ordo + " nace en 2015, en el cruce entre un encuentro con un universo particular y un momento en el que mi práctica buscaba un nuevo impulso. Este encuentro le aporta un movimiento dinámico, acorde con mis reflexiones sobre el espacio-tiempo de la humanidad, sobre las fuerzas visibles e invisibles que la atraviesan, sobre las memorias que actúan en ella y sobre las tensiones mediante las cuales cada ser busca su lugar en medio del mundo.",

        "La colección habla de nuestra humanidad, de sus luchas interiores, de sus deseos, de sus violencias, de sus impulsos, de sus contradicciones y de sus " + CANON.rezonans + " en el cosmos, en el universo, en la sociedad y en el Otro. Cada obra se convierte en una zona donde lo infinitamente íntimo encuentra lo infinitamente vasto, donde los conflictos individuales entran en relación con las tensiones colectivas y donde el color da una presencia sensible a las fuerzas que atraviesan lo vivo.",

        "El caos aparece como una pluralidad de formas, memorias, afectos y energías en espera de ordenamiento. El orden se convierte en una coherencia móvil, una forma de sostén capaz de acoger las diferencias preservando su intensidad. " + CANON.ordo + " despliega así una unidad heterogénea de la singularidad, una expresión plural de lo múltiple en la que las tensiones, los acercamientos, las rupturas y las recomposiciones participan juntas en la construcción de la obra.",

        "En esta colección se afirma la frase-fuente de 2015 que comienza con estas palabras: «&nbsp;Yo soy esta zona de contacto entre el contorno de la forma y el alrededor que constituye el espacio donde se expresa la forma.&nbsp;» El «&nbsp;Yo&nbsp;» que la abre pertenece a todos los «&nbsp;Yo&nbsp;» que la leen, la miran y la experimentan. Cada persona puede habitarla y convertirse en esa zona de contacto, ese espacio de fricciones, tensiones, dulzuras, fusiones, choques y distancias donde resuenan varios mundos, culturas, historias y afectos.",

        "Este «&nbsp;Yo&nbsp;» actúa como un lugar abierto. Acoge la singularidad de cada lector y la pone en relación con la multiplicidad del mundo. Quien entra en la frase se convierte, a su vez, en el punto de paso entre la forma y su alrededor, entre la experiencia íntima y la historia colectiva, entre lo que percibe y aquello que lo atraviesa. La lectura se vuelve entonces participación, y la obra se convierte en un espacio donde cada persona puede reconocer, desplazar y reacordar su propia relación con lo real.",

        "Este pensamiento porta ya los gérmenes del " + CANON.sujetPluriel + ", de los " + CANON.engrenages + ", de " + CANON.rezonans + " y de la estética del " + CANON.multiplePluriel + ", que más tarde recibirán su formulación en el " + CANON.posoennoisme + ". A través de " + CANON.ordo + ", la pintura hace perceptible el tumulto sin aplanarlo, ofrece a las tensiones una arquitectura, a las diferencias un espacio de relación y a los fragmentos una posibilidad de recomposición.",

        "Cada detalle participa así en una organización más amplia. El mundo conserva su intensidad, sus fracturas, sus distancias y sus devenires, mientras la obra hace surgir una forma capaz de contenerlos, desplazarlos y transformarlos. " + CANON.ordo + " se convierte entonces en un campo de paso donde el orden procede del caos, donde la singularidad se experimenta en lo múltiple y donde cada «&nbsp;Yo&nbsp;» puede entrar en la dinámica viva del conjunto."
      ]
    }
  };

  function normLang(raw){
    var value = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");

    if (value === "fr" || value.indexOf("fr-") === 0) return "fr";
    if (value === "en" || value.indexOf("en-") === 0) return "en";
    if (value === "es" || value.indexOf("es-") === 0) return "es";

    return "fr";
  }

  function readStoredLang(){
    var value = "";

    try {
      value = localStorage.getItem(STORAGE_KEY) || "";
    } catch(e) {
      value = "";
    }

    if (!value) {
      try {
        value = localStorage.getItem(STORAGE_KEY_COMPAT) || "";
      } catch(_e) {
        value = "";
      }
    }

    return value ? normLang(value) : "";
  }

  function getLang(){
    var stored = readStoredLang();
    var htmlLang = "";

    if (stored) return stored;

    try {
      htmlLang = document.documentElement.getAttribute("lang") || "";
    } catch(e) {
      htmlLang = "";
    }

    return htmlLang ? normLang(htmlLang) : "fr";
  }

  function storeLang(lang){
    var resolved = normLang(lang);

    try {
      localStorage.setItem(STORAGE_KEY, resolved);
    } catch(e) {}

    try {
      localStorage.setItem(STORAGE_KEY_COMPAT, resolved);
    } catch(_e) {}

    try {
      document.documentElement.setAttribute("lang", resolved);
    } catch(__e) {}

    return resolved;
  }

  function paragraphHTML(paragraphs){
    return paragraphs.map(function(paragraph){
      return '<p class="po-oac-collection__paragraph">' +
        paragraph +
        "</p>";
    }).join("");
  }

  function updateButtons(root, lang){
    var buttons = root.querySelectorAll("[data-po-lang]");

    Array.prototype.forEach.call(buttons, function(button){
      var active = normLang(button.getAttribute("data-po-lang")) === lang;

      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function updateUI(root, lang){
    var data = CONTENT[lang] || CONTENT.fr;
    var group = root.querySelector("[data-po-language-group]");
    var summaryLabel = root.querySelector("[data-po-summary-label]");
    var content = root.querySelector("[data-po-content]");
    var audio = root.querySelector("[data-po-audio]");

    root.setAttribute("lang", lang);
    root.setAttribute("aria-label", data.ui.content);

    if (group) group.setAttribute("aria-label", data.ui.group);
    if (summaryLabel) summaryLabel.textContent = data.ui.summary;
    if (content) content.setAttribute("aria-label", data.ui.content);

    if (audio) {
      audio.hidden = !AUDIO_SYNTH;
      audio.textContent = AUDIO_STATE.active && AUDIO_STATE.root === root
        ? data.ui.stop
        : data.ui.audio;
      audio.setAttribute(
        "aria-pressed",
        AUDIO_STATE.active && AUDIO_STATE.root === root ? "true" : "false"
      );
    }

    updateButtons(root, lang);
  }

  function renderRoot(root, lang){
    if (!root) return;

    var resolved = normLang(lang);
    var data = CONTENT[resolved] || CONTENT.fr;
    var content = root.querySelector("[data-po-content]");

    stopAudio();

    if (content) {
      content.classList.add("is-changing");

      window.setTimeout(function(){
        content.innerHTML = paragraphHTML(data.paragraphs);
        content.setAttribute("lang", resolved);
        content.classList.remove("is-changing");
      }, 80);
    }

    updateUI(root, resolved);
  }

  function applyLangEverywhere(lang){
    var resolved = normLang(lang);
    var roots = document.querySelectorAll(ROOT_SELECTOR);

    Array.prototype.forEach.call(roots, function(root){
      renderRoot(root, resolved);
    });
  }

  function notifyLocaleChanged(lang){
    try {
      window.dispatchEvent(new CustomEvent("po:locale-changed", {
        detail: {
          lang: lang,
          source: "po-ordo-ab-chaos-collection"
        }
      }));
    } catch(e) {
      try {
        var event = document.createEvent("CustomEvent");
        event.initCustomEvent("po:locale-changed", true, true, {
          lang: lang,
          source: "po-ordo-ab-chaos-collection"
        });
        window.dispatchEvent(event);
      } catch(_e) {}
    }
  }

  function setLang(lang){
    var resolved = storeLang(lang);

    applyLangEverywhere(resolved);
    notifyLocaleChanged(resolved);

    return resolved;
  }

  function cleanAudioText(text){
    return clampStr(text)
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function splitAudioText(text, maxLength){
    var clean = cleanAudioText(text);
    var limit = maxLength || 210;
    var sentences;
    var chunks = [];
    var current = "";

    if (!clean) return chunks;

    sentences = clean.match(/[^.!?…]+[.!?…]+|[^.!?…]+$/g) || [clean];

    sentences.forEach(function(sentence){
      var part = sentence.trim();

      if (!part) return;

      if (part.length > limit) {
        var words = part.split(/\s+/);

        words.forEach(function(word){
          var candidate = current ? current + " " + word : word;

          if (candidate.length > limit && current) {
            chunks.push(current.trim());
            current = word;
          } else {
            current = candidate;
          }
        });

        return;
      }

      if ((current + " " + part).trim().length > limit && current) {
        chunks.push(current.trim());
        current = part;
      } else {
        current = (current + " " + part).trim();
      }
    });

    if (current) chunks.push(current.trim());

    return chunks;
  }

  function voiceFor(lang){
    if (!AUDIO_SYNTH || typeof AUDIO_SYNTH.getVoices !== "function") {
      return null;
    }

    var voices = AUDIO_SYNTH.getVoices() || [];
    var locale = lang === "en" ? "en" : (lang === "es" ? "es" : "fr");
    var exact = null;
    var partial = null;

    voices.some(function(voice){
      var code = clampStr(voice.lang).toLowerCase();

      if (!exact && code === locale) exact = voice;
      if (!partial && code.indexOf(locale + "-") === 0) partial = voice;

      return Boolean(exact);
    });

    return exact || partial || null;
  }

  function refreshAudioButtons(){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    var lang = getLang();

    Array.prototype.forEach.call(roots, function(root){
      updateUI(root, lang);
    });
  }

  function resetAudioState(){
    AUDIO_STATE.root = null;
    AUDIO_STATE.chunks = [];
    AUDIO_STATE.index = 0;
    AUDIO_STATE.active = false;
    refreshAudioButtons();
  }

  function stopAudio(){
    if (AUDIO_SYNTH) {
      try {
        AUDIO_SYNTH.cancel();
      } catch(e) {}
    }

    resetAudioState();
  }

  function speakNext(){
    var root = AUDIO_STATE.root;
    var lang;
    var utterance;
    var voice;

    if (!AUDIO_SYNTH || !AUDIO_STATE.active || !root) {
      resetAudioState();
      return;
    }

    if (AUDIO_STATE.index >= AUDIO_STATE.chunks.length) {
      resetAudioState();
      return;
    }

    lang = normLang(root.getAttribute("lang") || getLang());
    utterance = new SpeechSynthesisUtterance(
      AUDIO_STATE.chunks[AUDIO_STATE.index]
    );
    voice = voiceFor(lang);

    utterance.lang = lang === "en"
      ? "en-US"
      : (lang === "es" ? "es-ES" : "fr-FR");
    utterance.rate = 0.94;
    utterance.pitch = 1;
    utterance.volume = 1;

    if (voice) utterance.voice = voice;

    utterance.onend = function(){
      AUDIO_STATE.index += 1;
      speakNext();
    };

    utterance.onerror = function(){
      resetAudioState();
    };

    AUDIO_SYNTH.speak(utterance);
  }

  function startAudio(root){
    var content;
    var text;

    if (!AUDIO_SYNTH || !root) return;

    if (AUDIO_STATE.active && AUDIO_STATE.root === root) {
      stopAudio();
      return;
    }

    stopAudio();

    content = root.querySelector("[data-po-content]");
    text = content ? content.textContent : "";

    AUDIO_STATE.root = root;
    AUDIO_STATE.chunks = splitAudioText(text, 210);
    AUDIO_STATE.index = 0;
    AUDIO_STATE.active = AUDIO_STATE.chunks.length > 0;

    refreshAudioButtons();

    if (AUDIO_STATE.active) speakNext();
  }

  function bindRoot(root){
    if (!root || root.getAttribute("data-po-bound") === "true") return;

    root.setAttribute("data-po-bound", "true");

    root.addEventListener("click", function(event){
      var langButton = event.target.closest("[data-po-lang]");
      var audioButton = event.target.closest("[data-po-audio]");

      if (langButton && root.contains(langButton)) {
        event.preventDefault();
        setLang(langButton.getAttribute("data-po-lang"));
        return;
      }

      if (audioButton && root.contains(audioButton)) {
        event.preventDefault();
        startAudio(root);
      }
    });
  }

  function initRoots(){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    var lang = getLang();

    Array.prototype.forEach.call(roots, function(root){
      bindRoot(root);
      renderRoot(root, lang);
    });
  }

  window.addEventListener("po:locale-changed", function(event){
    var detail = event && event.detail ? event.detail : null;
    var lang = detail && detail.lang ? detail.lang : getLang();

    if (detail && detail.source === "po-ordo-ab-chaos-collection") return;

    applyLangEverywhere(lang);
  });

  window.addEventListener("storage", function(event){
    if (!event) return;

    if (event.key === STORAGE_KEY || event.key === STORAGE_KEY_COMPAT) {
      applyLangEverywhere(event.newValue || getLang());
    }
  });

  document.addEventListener("shopify:section:load", function(){
    initRoots();
  });

  document.addEventListener("shopify:section:unload", function(){
    stopAudio();
  });

  window.addEventListener("pagehide", function(){
    stopAudio();
  });

  window.PoOrdoAbChaosCollectionFR_EN_ES_20260727 = {
    getLang: getLang,
    setLang: setLang,
    init: initRoots,
    stopAudio: stopAudio
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRoots, { once: true });
  } else {
    initRoots();
  }
})();
